"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldGroupOf = exports.FieldGroup = void 0;
exports.sideSegment = sideSegment;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
/**
 * The field groups amount formats are stored under, in the database of field defaults and in a
 * user's own saved formats.
 *
 * A field group covers a whole properties selector, so the inputs are laid out one selector per
 * section and each section holds properties of a single group. That is what lets a unit chosen
 * for a common property carry across every coil type instead of being remembered once per coil.
 */
exports.FieldGroup = {
    common: "CoilProTool.Inputs.Common",
    fluid: "CoilProTool.Inputs.Fluid",
    dx: "CoilProTool.Inputs.Dx",
    steam: "CoilProTool.Inputs.Steam",
    results: "CoilProTool.Results"
};
exports.FieldGroupOf = {
    common: exports.FieldGroup.common,
    fluid: exports.FieldGroup.fluid,
    dx: exports.FieldGroup.dx,
    steam: exports.FieldGroup.steam
};
/** DX and condenser share one input side, so they share its segment. */
function sideSegment(coilType) {
    switch (coilType) {
        case "fluid":
            return "fluid";
        case "steam":
            return "steam";
        case "dx":
        case "condenser":
            return "dx";
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(coilType);
            throw new Error(`No input segment for coil type ${coilType}`);
    }
}
//# sourceMappingURL=field-groups.js.map